import { useEffect, useRef, useState } from 'react'

export interface RailHoverGeometry {
  anchor: DOMRect
  card: DOMRect
}

// Placed against the edge of the closest `data-rail-card`, or of the icon itself without one.
const useRailHoverLabel = <T extends HTMLElement = HTMLDivElement>() => {
  const anchorRef = useRef<T>(null)
  const [geometry, setGeometry] = useState<RailHoverGeometry | null>(null)

  const show = () => {
    const anchor = anchorRef.current
    if (!anchor) return
    const anchorRect = anchor.getBoundingClientRect()
    const card = anchor.closest('[data-rail-card]')
    setGeometry({ anchor: anchorRect, card: card?.getBoundingClientRect() ?? anchorRect })
  }

  const hide = () => setGeometry(null)

  useEffect(() => {
    if (!geometry) return undefined
    window.addEventListener('scroll', hide, true)
    return () => window.removeEventListener('scroll', hide, true)
  }, [geometry])

  return { anchorRef, geometry, show, hide }
}

export default useRailHoverLabel
